import Hilton from "assets/hilton.png";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import { isEmpty, isUndefined } from "lodash";
import { useAppSelector } from "redux/hooks";

const PrivacyNotice = (props: any) => {
  const { open, setOpen } = props;
  const privacyContent = useAppSelector((state) => state.PrivacyAndDisclaimer.privacyAndDisclaimer);
  const result: any =
    !isEmpty(privacyContent) &&
    Object.values(privacyContent)?.length &&
    Object.values(privacyContent).find((item: any) => item.type === "privacy_notice");
  return (
    <>
      {!isUndefined(result.content) && open && (
        <DialogFormation
          title="Notice Regarding the Collection of Personal Data"
          openDialog={open}
          handleClose={() => setOpen(false)}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button onClick={() => setOpen(false)} label={"Close"}></Button>
            </div>
          }
        >
          <>
            <div className="m-b-16">
              <img src={Hilton} />
            </div>
            <div dangerouslySetInnerHTML={{ __html: result.content }}></div>
          </>
        </DialogFormation>
      )}
    </>
  );
};

export default PrivacyNotice;
